import { render, staticRenderFns } from "./JobDetailView.vue?vue&type=template&id=7c68a88c&"
import script from "./JobDetailView.vue?vue&type=script&lang=js&"
export * from "./JobDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports